<script setup>
import { ref, onMounted } from 'vue';

const emit = defineEmits(['done']);
const show = ref(true);
const logoVisible = ref(false);
const loaderVisible = ref(false);

onMounted(() => {
  // Animate logo in
  setTimeout(() => { logoVisible.value = true; }, 100);
  // Show loader
  setTimeout(() => { loaderVisible.value = true; }, 500);
  // Hide splash after 2s
  setTimeout(() => {
    show.value = false;
    setTimeout(() => emit('done'), 400); // wait for fade-out
  }, 2000);
});
</script>

<template>
  <Transition
    enter-active-class="transition-opacity duration-300"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition-opacity duration-400 ease-in"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div v-if="show" class="fixed inset-0 z-[9999] bg-white flex flex-col items-center justify-center">
      
      <!-- Full Clo'Cook Logo -->
      <div 
        class="transition-all duration-700 ease-out"
        :class="logoVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-75'"
      >
        <img src="/assets/legacy/logo_yellow.svg" alt="Clo'Cook" class="h-16 w-auto" />
      </div>
      
      <!-- Slogan -->
      <p 
        class="text-base text-gray-500 font-semibold mt-4 transition-all duration-500 delay-300"
        :class="logoVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'"
      >
        Fini la charge mentale !
      </p>

      <!-- Loader dots -->
      <div 
        class="flex gap-1.5 mt-8 transition-opacity duration-300"
        :class="loaderVisible ? 'opacity-100' : 'opacity-0'"
      >
        <span class="w-2 h-2 rounded-full bg-[#e94591] animate-bounce" style="animation-delay: 0ms"></span>
        <span class="w-2 h-2 rounded-full bg-[#e94591] animate-bounce" style="animation-delay: 150ms"></span>
        <span class="w-2 h-2 rounded-full bg-[#e94591] animate-bounce" style="animation-delay: 300ms"></span>
      </div>
    </div>
  </Transition>
</template>
